export const getStatusColor = (status: string): [string, string] => {
  switch (status?.toLowerCase()) {
    case 'sent':
    case 'completed':
      return ['#4caf50', '#e8f5e8'];
    case 'pending':
    case 'processing':
      return ['#ff9800', '#fff3e0'];
    case 'failed':
      return ['#f44336', '#ffebee'];
    default:
      return ['#666666', '#f5f5f5'];
  }
};
